/**
 * Theme picker — applies an explicit `data-theme` attribute on <html> so
 * the CSS-variable overrides in style.css kick in. 'auto' removes the
 * attribute so the OS-level `prefers-color-scheme` media query wins.
 */
import { setStoredTheme } from './storage';
import type { ThemeMode } from './types';

export function applyTheme(theme: ThemeMode): void {
  if (theme === 'auto') {
    document.documentElement.removeAttribute('data-theme');
  } else {
    document.documentElement.setAttribute('data-theme', theme);
  }
  setStoredTheme(theme);
}
